import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations.js";
import actions from "./actions.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginModal: false,
    loggedIn: false,
    modalType: null,
    topWszech: null,
    polskiTopWszech: null,
    genericModalText: "",
    searchQuery: null,
    searchCategory: "",
    selectedNote: null,
    searchActive: false,
    currentListId: null,
    redirectModal: true,
  },
  mutations,
  actions,
});
